import FileInfo from './dialogs/FileInfo.vue'
import * as fileStoreService from '@/features/filestore/FileStoreService.js'
import NameDialog from '@/features/filestore/dialogs/NameDialog.vue'
import FolderTreeBrowser from '@/features/filestore/dialogs/FolderTreeBrowser.vue'
import TrashInfo from '@/features/filestore/dialogs/TrashInfo.vue'
import { EventBus, Events } from '@/eventbus/EventBus'
import { mapStores } from 'pinia'
import { useFileStoreStore } from '@/features/filestore/FileStore.store'
import ConfirmationDialog from '@/dialogs/ConfirmationDialog.vue'

export default {
  computed: {
    ...mapStores(useFileStoreStore)
  },
  methods: {
    fileOrFolderClicked(file) {
      if (file === undefined) return

      if (file.type === 'folder') {
        this.$router.push({
          name: 'fileStoreFolder',
          params: { archiveId: file.archiveId, folderId: file.folderId }
        })
      }

      if (file.type === 'file') {
        this.toggleSelectedFile(file.fileId)
      }
    },
    confirmationDialog(text, actionLabel, callback) {
      this.$modal.show(
        ConfirmationDialog,
        {
          text: text,
          buttons: [
            {
              title: 'Annuleren',
              class: 'pill-button secondary'
            },
            {
              title: actionLabel,
              class: 'pill-button',
              handler: () => {
                callback()
              }
            }
          ]
        },
        {
          width: 400,
          height: 'auto'
        }
      )
    },
    trashFolder(folder) {
      this.confirmationDialog(
        `Weet u zeker dat u de map <strong>${folder.name}</strong> en alle inhoud naar de prullenmand wilt verplaatsen?`,
        'Naar prullenmand',
        () => fileStoreService.trashFolder(folder)
      )
    },
    getFileInfo(file) {
      this.$modal.show(
        FileInfo,
        {
          file: file
        },
        {
          width: 650
        }
      )
    },
    getTrashInfo(file) {
      this.$modal.show(
        TrashInfo,
        {
          file: file
        },
        {
          width: 650
        }
      )
    },
    viewFile(file) {
      window.open(`/api/v1/fileview.php?fileId=${file.fileId}`, '_blank')
    },
    // Start een download zonder de huidige pagina te verlaten. window.location
    // navigeert de SPA weg zodra de server geen bestand maar een foutpagina teruggeeft.
    triggerDownload(url) {
      const link = document.createElement('a')
      link.href = url
      link.download = ''
      link.style.display = 'none'
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    },
    downloadFile(fileIds) {
      const ids = Array.isArray(fileIds) ? fileIds : [fileIds]

      if (ids.length === 0) return

      this.triggerDownload(`/api/v1/filedownload.php?fileIds=${ids.join(',')}`)
    },
    trashFile(file) {
      this.trashFiles([file.fileId])
    },
    trashSelectedFiles() {
      const selectedIds = this.fileStoreStore.browserSelectedFileIds
      this.trashFiles(selectedIds)
    },
    trashFiles(fileIds) {
      this.confirmationDialog(
        `Weet u zeker dat u <strong>${
          fileIds.length > 1
            ? 'de geselecteerde bestanden'
            : 'het geselecteerde bestand'
        }</strong> naar de prullenmand wilt verplaatsen?`,
        'Naar prullenmand',
        () => {
          fileStoreService.trashFiles(fileIds)
          this.fileStoreStore.clearBrowserSelectedFileIds()

          EventBus.emit(Events.FILES_TRASHED, fileIds)
        }
      )
    },
    navigateToTargetFolder(folderId) {
      const folder = this.fileStoreStore.getFolder(folderId)

      this.fileOrFolderClicked(folder)
    },
    toggleSelectedFile(fileId) {
      if (this.fileStoreStore.browserSelectedFileIds.includes(fileId)) {
        this.fileStoreStore.browserDeSelectFileId(fileId)
      } else {
        this.fileStoreStore.browserSelectedFileId(fileId)
      }
    }
  }
}
